export default __webpack_public_path__ + "static/media/48-vasily.0fa0acae.jpg";